import { lazy } from "react";

const ListAudioAiPage = lazy(() => import("./main"));

const UpdateAudioAiPage = lazy(() => import("./update"));

const ViewAudioAiPage = lazy(() => import("./view"));

export { ListAudioAiPage, UpdateAudioAiPage, ViewAudioAiPage };
